import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { serviceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/casi-uso/studi-legali-piccoli")({
  head: () => seoMeta({
    title: "LexAIPro per piccoli studi legali",
    description: "Coordinamento, condivisione di pratiche e produttività per piccoli studi legali italiani fino a 10 professionisti.",
    path: "/casi-uso/studi-legali-piccoli",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[serviceSchema({ name: "LexAIPro per piccoli studi legali", description: "AI legale pensata per studi fino a 10 professionisti: collaborazione e condivisione di pratiche.", path: "/casi-uso/studi-legali-piccoli", category: "Legal AI" })]}
      eyebrow="Casi d'uso"
      title="LexAIPro per piccoli studi (2-10 avvocati)"
      lead="Standardizza la qualità del lavoro tra collaboratori, condividi template e pratiche, libera i partner dalla supervisione di routine."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Casi d'uso",path:"/casi-uso/studi-legali-piccoli"},{name:"Piccoli studi",path:"/casi-uso/studi-legali-piccoli"}]}
      sections={[
        { heading: "Benefici", bullets: ["Template comuni dello studio","Pratiche condivise tra collaboratori","Onboarding rapido di nuovi praticanti","Reportistica per partner"] },
      ]}
      cta={{ label: "Prova lo studio", to: "/signup" }}
      heroImage={pickContent(25)}
      updated="2026"
    />
  ),
});
